import React from 'react';
import { FormBuilder } from 'commons-ui';

import { EDIT_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, editValidationSchema } from '../../formConfig';

import useEdit from './useEdit';

const EditSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={editValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={EDIT_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: 'Back', submitLabel: 'Submit' }}
		/>
	);
};

export default EditSegment;
